import type { ComponentProps } from 'react'
import AeoResults from '@/app/(app)/tools/aeo-page-auditor/components/AeoResults'
import type { ToolDetailProps } from './detailRegistry'

/**
 * Dashboard detail renderer for `aeo` (Phase 3, Step 6 — Class A, dashboard-reuse).
 *
 * REUSES the public `AeoResults` component with `variant="dashboard"`, which hides
 * the public-only chrome (PlatformCTA + the gradient services CTA). The platform
 * route (`/api/platform/tools/aeo-auditor`) runs the same lib and returns the same
 * `AeoAuditResult`, so the dashboard `data` maps straight onto `AeoResults` — the
 * dashboard now shows the full rich AEO report (score ring, AI analysis incl.
 * `context`, the 6 category cards, recommendations + blog links) instead of the old
 * generic panel.
 *
 * Wrapped in `id="tool-detail-panel"` so the dashboard's scroll-to-panel still
 * works. Render-layer only; grade comes from `data.grade` via the reused component
 * (never recomputed). AEO's 6 categories render through `AeoScoreCard`, NOT
 * `ReadinessRadar`.
 */
export function AeoDashboardDetail({ data }: ToolDetailProps) {
  const result = data as unknown as ComponentProps<typeof AeoResults>['result']
  return (
    <div
      id='tool-detail-panel'
      className='rounded-xl border border-border bg-card p-5'
    >
      <AeoResults result={result} variant='dashboard' />
    </div>
  )
}
